import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React, { useEffect } from 'react';
import { useUserContext } from '@fff-web/fff-utilities';
import { loadRecurly } from '@fff-web/fff-payments';
import SocialEcommRegistration from '../../components/SocialEcomm/SocialEcomm';
import FriendProvider from '../../utils/ContextProviders/FriendContext';
import env from '../../utils/env';

type Flags = {
  friendAccountCreation: boolean,
};
type Props = {
  flags?: Flags
};

const SocialEcommRegistrationPage = ({ flags }: Props) => {
  const { userInfo } = useUserContext();
  // REDIRECT USER TO HOMEPAGE IF FLAG IS OFF
  useEffect(() => {
    const friendAccountCreation = flags?.friendAccountCreation;
    const userIsLoggedIn = userInfo.loggedIn;
    if (!friendAccountCreation || userIsLoggedIn) {
      window.location.assign(`https://${env.originUrl}`);
    }
  }, [flags, userInfo.loggedIn]);

  useEffect(() => {
    loadRecurly();
  });
  return (
    <FriendProvider>
      <SocialEcommRegistration flags={flags} />
    </FriendProvider>
  );
};

SocialEcommRegistrationPage.defaultProps = {
  flags: {
    friendAccountCreation: true,
  },
};

export default withLDConsumer()(SocialEcommRegistrationPage);
